var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJ2Export(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60 50V40H25v-4h35V26l12.91 12L60 50zm-14.59 3.91a22.33 22.33 0 01-7.15 4.82 22.65 22.65 0 01-17.52 0 22.51 22.51 0 010-41.46 22.65 22.65 0 0117.52 0 22.57 22.57 0 0112 12l3.69-1.56a26.47 26.47 0 100 20.64l-3.69-1.56a22.33 22.33 0 01-4.85 7.12z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/J2_Export.8723a816.svg";
export { SvgJ2Export as ReactComponent };